import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putRegularClassSchedulesSimulate = ({ id, ...data }) => {
  return api.put(`admin/regular-class-schedules-simulate/${id}`, data);
};

export const putRegularClassSchedulesSimulateQueryOptions = data => {
  return queryOptions({
    queryKey: ["put-regular-class-schedules-simulate", data],
    queryFn: () => putRegularClassSchedulesSimulate(data),
  });
};

export const usePutRegularClassSchedulesSimulate = ({
  queryConfig = {},
  ...data
}) => {
  return useQuery({
    ...putRegularClassSchedulesSimulateQueryOptions(data),
    ...queryConfig,
  });
};
